import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import { Container, Typography, TextField, Button, Box } from "@mui/material";

const Contact = () => {
  const { ref, inView } = useInView({ threshold: 0.3 });

  return (
    <section
      id="contact"
      ref={ref}
      style={{
        background: "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)",
        padding: "100px 20px"
      }}
    >
      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={
          inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }
        }
        transition={{ duration: 0.8 }}
        style={{
          maxWidth: "900px",
          margin: "auto",
          padding: "40px",
          borderRadius: "16px",
          backdropFilter: "blur(10px)",
          background: "rgba(255, 255, 255, 0.4)",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)"
        }}
      >
        <Typography
          variant="h4"
          textAlign="center"
          gutterBottom
          sx={{ color: "#333" }}
        >
          Contact Us
        </Typography>

        <Box
          sx={{
            maxWidth: 500,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            textAlign: "center",
            padding: "20px"
          }}
        >
          <Typography variant="h6" sx={{ color: "#444", fontWeight: "bold" }}>
            หน่วยสารเสพติด สถาบันวิจัยวิทยาศาสตร์สุขภาพ มหาวิทยาลัยเชียงใหม่
          </Typography>
          <Typography variant="body1" sx={{ color: "#666" }}>
            โทรศัพท์ 0-5394-2508 ต่อ 304
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <motion.iframe
            initial={{ opacity: 0, scale: 0.8 }}
            animate={
              inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
            }
            transition={{ duration: 0.6, delay: 0.2 }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d944.2651849660036!2d98.95754596962303!3d18.795446268487385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da3a65438afbf9%3A0xae7fec80cbb1287f!2zMjM5IOC4luC4meC4mSDguKvguYnguKfguKLguYHguIHguYnguKcg4LiV4Liz4Lia4Lil4Liq4Li44LmA4LiX4LieIOC4reC4s-C5gOC4oOC4reC5gOC4oeC4t-C4reC4h-C5gOC4iuC4teC4ouC4h-C5g-C4q-C4oeC5iCDguYDguIrguLXguKLguIfguYPguKvguKHguYggNTAyMDA!5e0!3m2!1sth!2sth!4v1750149692301!5m2!1sth!2sth"
            width="100%"
            height="400"
            style={{
              borderRadius: "12px",
              border: "none",
              boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
              maxWidth: "600px"
            }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          />
        </Box>
      </motion.div>
    </section>
  );
};

export default Contact;
